import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {SelectStaffComponent} from '../../../ui/selectstaff/selectstaff.component';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {StaffsService} from '../../../../service/staff/service-staffs';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
@Component({
  templateUrl: './join.component.html'

})
export class JoinToTrinhComponent implements OnInit, AfterViewInit {
  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  public language = language;
  public id: number=0;
  public isEdit: boolean = false;
  public submitValidate = false;
  public defaultValue: number[]=[];
  public staffSelectList: Object[]=[];
  public selectedList: Object[]=[];
  public onClose: Subject<boolean>;

  constructor( public toTrinhService: ToTrinhService,
               public staffsService: StaffsService,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef


  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public edit(id: number) {
    this.id= id;
  }
  public createItem ()
  {

    this.toTrinhService.joinToTrinh(this.id, this.uiSelectStaff.selected.join()).subscribe(
      {
        next: (data) => {
          this.toastr.success(language.message_add_nguoinhan_success, language.message);
          this.onConfirm();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });

  }

  public showGroup()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-lg'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for (let i = 0; i < result.length; i++) {

          if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
            this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
            this.selectedList= [...this.selectedList, result[i].id];
          }
        }
      }
    });
  }
  onSubmit()
  {
    if(this.uiSelectStaff.selected.length>0) {
      this.createItem();
    }
    else {
      this.toastr.error(language.error_select_staff_share, language.message);
    }
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

